import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const CustomerGroupQuery = gql`
  query {
    customerGroupList {
      id
      name
      discount
      fields
      description
      email
      createdAt
      PohodaIDS
    }
    languages {
      id
      value
    }
  }
`;

const CreateCustomerGroupMutation = gql`
  mutation($customerGroup: CustomerGroupInput!) {
    createCustomerGroup(customerGroup: $customerGroup) {
      id
    }
  }
`;

const UpdateCustomerGroupMutation = gql`
  mutation($id: String!, $customerGroup: CustomerGroupInput!) {
    updateCustomerGroup(id: $id, customerGroup: $customerGroup) {
      id
    }
  }
`;

const DeleteCustomerGroupMutation = gql`
  mutation($id: String!) {
    deleteCustomerGroup(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetCustomerGroupQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { customerGroupList, createCustomerGroup, updateCustomerGroup, deleteCustomerGroup }: any = this.props;
    return this.props.children({ customerGroupList, createCustomerGroup, updateCustomerGroup, deleteCustomerGroup });
  }
}

export default compose(
  graphql<IInputProps, Response>(CustomerGroupQuery, {
    name: 'customerGroupList'
  }),
  graphql<IInputProps, Response>(CreateCustomerGroupMutation, {
    name: 'createCustomerGroup'
  }),
  graphql<IInputProps, Response>(UpdateCustomerGroupMutation, {
    name: 'updateCustomerGroup'
  }),
  graphql<IInputProps, Response>(DeleteCustomerGroupMutation, {
    name: 'deleteCustomerGroup'
  })
)(GetCustomerGroupQuery);



// WEBPACK FOOTER //
// ./src/components/Query/CustomerGroup/CustomerGroup.tsx